import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBarChartIncomplete = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 400,
	height: 287,
	viewBox: "0 0 400 287",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M0 224H400V225H0V224Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .8,
			d: "M24 73C24 70.8 25.2 69 26.7 69H30.8C32.3 69 33.5 70.8 33.5 73V224H24C24 164.8 24 131.1 24 73Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .2,
			d: "M36.2002 40C36.2002 37.8 37.4002 36 38.9002 36H43.0002C44.5002 36 45.7002 37.8 45.7002 40V224H36.2002V40Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .8,
			d: "M60.7002 89C60.7002 86.8 61.9002 85 63.4002 85H67.5002C69.0002 85 70.2002 86.8 70.2002 89V224H60.7002V89Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .2,
			d: "M72.9004 96C72.9004 93.8 74.1004 92 75.6004 92H79.7004C81.2004 92 82.4004 93.8 82.4004 96V224H72.9004V96Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .8,
			d: "M97.2998 65C97.2998 62.8 98.4998 61 99.9998 61H104.1C105.6 61 106.8 62.8 106.8 65V224H97.2998V65Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .2,
			d: "M109.5 56C109.5 53.8 110.7 52 112.2 52H116.3C117.8 52 119 53.8 119 56V224H109.5V56Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .8,
			d: "M243.3 65C243.3 62.8 244.5 61 246 61H250.1C251.6 61 252.8 62.8 252.8 65V224H243.3V65Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .2,
			d: "M255.5 56C255.5 53.8 256.7 52 258.2 52H262.3C263.8 52 265 53.8 265 56V224H255.5V56Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .8,
			d: "M134 23C134 20.8 135.2 19 136.7 19H140.8C142.3 19 143.5 20.8 143.5 23V224H134V23Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .2,
			d: "M146.2 48C146.2 45.8 147.4 44 148.9 44H153C154.5 44 155.7 45.8 155.7 48V224H146.2V48Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .8,
			d: "M170.6 150C170.6 147.8 171.8 146 173.3 146H177.4C178.9 146 180.1 147.8 180.1 150V224H170.6V150Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .2,
			d: "M182.9 132C182.9 129.8 184.1 128 185.6 128H189.7C191.2 128 192.4 129.8 192.4 132V224H182.9V132Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .8,
			d: "M207.3 102C207.3 99.8 208.5 98 210 98H214.1C215.6 98 216.8 99.8 216.8 102V224H207.3V102Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .2,
			d: "M219.5 108C219.5 105.8 220.7 104 222.2 104H226.3C227.8 104 229 105.8 229 108V224H219.5V108Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .8,
			d: "M352.2 65C352.2 62.8 353.4 61 354.9 61H359C360.5 61 361.7 62.8 361.7 65V224H352.2V65Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .2,
			d: "M364.4 56C364.4 53.8 365.6 52 367.1 52H371.2C372.7 52 373.9 53.8 373.9 56V224H364.4V56Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .8,
			d: "M279.5 150C279.5 147.8 280.7 146 282.2 146H286.3C287.8 146 289 147.8 289 150V224H279.5V150Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .2,
			d: "M291.8 132C291.8 129.8 293 128 294.5 128H298.6C300.1 128 301.3 129.8 301.3 132V224H291.8V132Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .8,
			d: "M316.2 102C316.2 99.8 317.4 98 318.9 98H323C324.5 98 325.7 99.8 325.7 102V224H316.2V102Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .2,
			d: "M328.4 108C328.4 105.8 329.6 104 331.1 104H335.2C336.7 104 337.9 105.8 337.9 108V224H328.4V108Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .8,
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M102 255.5C102 254.1 103.1 253 104.5 253H111.5C112.9 253 114 254.1 114 255.5V262.5C114 263.9 112.9 265 111.5 265H104.5C103.1 265 102 263.9 102 262.5V255.5Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M170 255H118V263H170V255Z",
			fill: "white",
			fillOpacity: .5
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M201 255.5C201 254.1 202.1 253 203.5 253H210.5C211.9 253 213 254.1 213 255.5V262.5C213 263.9 211.9 265 210.5 265H203.5C202.1 265 201 263.9 201 262.5V255.5Z",
			fill: "white",
			fillOpacity: .5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M294 255H217V263H294V255Z",
			fill: "white",
			fillOpacity: .3
		})
	]
});
export default SvgBarChartIncomplete;
